import { render, staticRenderFns } from "./BuscaNeopagBack.vue?vue&type=template&id=569a4ebd&"
import script from "./BuscaNeopagBack.vue?vue&type=script&lang=js&"
export * from "./BuscaNeopagBack.vue?vue&type=script&lang=js&"
import style0 from "./BuscaNeopagBack.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports